<button mat-button class="button" (click)="openQuickpanel()" fxFlex="grow">
  <mat-icon>format_align_center</mat-icon>
</button>
